"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "API", {
  enumerable: true,
  get: function () {
    return _api.API;
  }
});
Object.defineProperty(exports, "BaseBackend", {
  enumerable: true,
  get: function () {
    return _basebackend.BaseBackend;
  }
});
Object.defineProperty(exports, "BaseClient", {
  enumerable: true,
  get: function () {
    return _baseclient.BaseClient;
  }
});
Object.defineProperty(exports, "Hub", {
  enumerable: true,
  get: function () {
    return _hub.Hub;
  }
});
exports.Integrations = void 0;
Object.defineProperty(exports, "NoopTransport", {
  enumerable: true,
  get: function () {
    return _noop.NoopTransport;
  }
});
Object.defineProperty(exports, "SDK_VERSION", {
  enumerable: true,
  get: function () {
    return _version.SDK_VERSION;
  }
});
Object.defineProperty(exports, "Scope", {
  enumerable: true,
  get: function () {
    return _hub.Scope;
  }
});
Object.defineProperty(exports, "Session", {
  enumerable: true,
  get: function () {
    return _hub.Session;
  }
});
Object.defineProperty(exports, "addBreadcrumb", {
  enumerable: true,
  get: function () {
    return _minimal.addBreadcrumb;
  }
});
Object.defineProperty(exports, "addGlobalEventProcessor", {
  enumerable: true,
  get: function () {
    return _hub.addGlobalEventProcessor;
  }
});
Object.defineProperty(exports, "captureEvent", {
  enumerable: true,
  get: function () {
    return _minimal.captureEvent;
  }
});
Object.defineProperty(exports, "captureException", {
  enumerable: true,
  get: function () {
    return _minimal.captureException;
  }
});
Object.defineProperty(exports, "captureMessage", {
  enumerable: true,
  get: function () {
    return _minimal.captureMessage;
  }
});
Object.defineProperty(exports, "configureScope", {
  enumerable: true,
  get: function () {
    return _minimal.configureScope;
  }
});
Object.defineProperty(exports, "createTransport", {
  enumerable: true,
  get: function () {
    return _base.createTransport;
  }
});
Object.defineProperty(exports, "eventToSentryRequest", {
  enumerable: true,
  get: function () {
    return _request.eventToSentryRequest;
  }
});
Object.defineProperty(exports, "getCurrentHub", {
  enumerable: true,
  get: function () {
    return _hub.getCurrentHub;
  }
});
Object.defineProperty(exports, "getEnvelopeEndpointWithUrlEncodedAuth", {
  enumerable: true,
  get: function () {
    return _api.getEnvelopeEndpointWithUrlEncodedAuth;
  }
});
Object.defineProperty(exports, "getHubFromCarrier", {
  enumerable: true,
  get: function () {
    return _hub.getHubFromCarrier;
  }
});
Object.defineProperty(exports, "getReportDialogEndpoint", {
  enumerable: true,
  get: function () {
    return _api.getReportDialogEndpoint;
  }
});
Object.defineProperty(exports, "getRequestHeaders", {
  enumerable: true,
  get: function () {
    return _api.getRequestHeaders;
  }
});
Object.defineProperty(exports, "getStoreEndpointWithUrlEncodedAuth", {
  enumerable: true,
  get: function () {
    return _api.getStoreEndpointWithUrlEncodedAuth;
  }
});
Object.defineProperty(exports, "initAPIDetails", {
  enumerable: true,
  get: function () {
    return _api.initAPIDetails;
  }
});
Object.defineProperty(exports, "initAndBind", {
  enumerable: true,
  get: function () {
    return _sdk.initAndBind;
  }
});
Object.defineProperty(exports, "makeMain", {
  enumerable: true,
  get: function () {
    return _hub.makeMain;
  }
});
Object.defineProperty(exports, "sessionToSentryRequest", {
  enumerable: true,
  get: function () {
    return _request.sessionToSentryRequest;
  }
});
Object.defineProperty(exports, "setContext", {
  enumerable: true,
  get: function () {
    return _minimal.setContext;
  }
});
Object.defineProperty(exports, "setExtra", {
  enumerable: true,
  get: function () {
    return _minimal.setExtra;
  }
});
Object.defineProperty(exports, "setExtras", {
  enumerable: true,
  get: function () {
    return _minimal.setExtras;
  }
});
Object.defineProperty(exports, "setTag", {
  enumerable: true,
  get: function () {
    return _minimal.setTag;
  }
});
Object.defineProperty(exports, "setTags", {
  enumerable: true,
  get: function () {
    return _minimal.setTags;
  }
});
Object.defineProperty(exports, "setUser", {
  enumerable: true,
  get: function () {
    return _minimal.setUser;
  }
});
Object.defineProperty(exports, "startTransaction", {
  enumerable: true,
  get: function () {
    return _minimal.startTransaction;
  }
});
Object.defineProperty(exports, "withScope", {
  enumerable: true,
  get: function () {
    return _minimal.withScope;
  }
});

var _minimal = require("@sentry/minimal");

var _hub = require("@sentry/hub");

var _api = require("./api");

var _baseclient = require("./baseclient");

var _basebackend = require("./basebackend");

var _request = require("./request");

var _sdk = require("./sdk");

var _noop = require("./transports/noop");

var _base = require("./transports/base");

var _version = require("./version");

var Integrations = _interopRequireWildcard(require("./integrations"));

exports.Integrations = Integrations;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }